/** The applicant registration queue, its dialogs, the approval refusals and the one-time password (plan F3). */
export default {
  title: 'Applicant registrations',
  subtitle: 'Consultants who asked for an applicant account. Approving one uses a viewer seat.',
  notPermitted:
    'Only a tenant administrator, or an approver officer once an administrator allows it, can review registrations.',
  filterLabel: 'Filter registrations',
  status: {
    submitted: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    superseded: 'Superseded',
    expired: 'Expired',
    all: 'All',
  },
  statusReason: {
    quota: 'Too many requests for this email',
    stale: 'Not reviewed within 30 days',
  },
  columns: {
    firm: 'Firm',
    regNo: 'Registration no.',
    requested: 'Requested',
  },
  empty: 'No registrations here.',
  total: 'Registrations: {{total}}',
  approve: 'Approve',
  reject: 'Reject',
  reviewed: 'Reviewed by {{name}} on {{date}}',
  reason: 'Reason: {{reason}}',
  approveTitle: 'Approve this registration?',
  approveBody: '{{name}} ({{email}}) gets an applicant account on a viewer seat.',
  cancel: 'Cancel',
  approvedEmail: 'Approved. An invitation was sent to {{email}}.',
  approvedExisting: 'Approved. The existing account was added to the applicants.',
  approvedPassword: 'Approved. Give the applicant the temporary password.',
  identityExistsGuest: 'An account with this email already exists here as a guest viewer.',
  addToApplicants: 'Add that account to the applicants',
  identityExistsOther:
    'An account with this email already exists here and is not a guest viewer, so it cannot become an applicant. Ask the person to register with another email.',
  emailInUse:
    'This email belongs to an account in another organisation on this service, so it cannot be registered here. Ask the applicant to use a different email.',
  roles: {
    admin: 'administrator',
    publisher: 'publisher',
    viewer: 'viewer',
  },
  seatsPurchasable: 'All {{role}} seats are in use ({{used}} of {{limit}}). Add seats to approve this registration.',
  openBilling: 'Open Settings → Billing',
  seatsAskAdmin: 'All {{role}} seats are in use ({{used}} of {{limit}}). Ask a tenant administrator to add seats.',
  licencePoolFull: 'Licence pool full: all {{role}} seats ({{used}} of {{limit}}) are in use.',
  seatsOperator: 'All {{role}} seats are in use ({{used}} of {{limit}}). Ask your service operator for more seats.',
  seatsBusy: 'Another account is being created right now. Try again in a moment.',
  notPending: 'This registration was already decided. The list has been refreshed.',
  rejectTitle: 'Reject this registration?',
  rejectReasonLabel: 'Reason (the applicant sees it)',
  rejectReasonRequired: 'Enter a reason.',
  rejected: 'Registration rejected.',
  passwordTitle: 'Temporary password',
  passwordBody:
    'Give this password to {{email}} through a channel you trust. They must change it at their first sign-in.',
  passwordOnce: 'It is shown only once and is not stored anywhere. Copy it now.',
  copy: 'Copy',
  copied: 'Copied',
  passwordDone: 'I have copied it',
} as const
